// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'babel-polyfill'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import Vue from 'vue'
import _ from 'lodash'
import VModal from 'vue-js-modal'
import VeeValidator, { Validator } from 'vee-validate'
import VeeValidatorKo from 'vee-validate/dist/locale/ko'
import Storage from 'vue-web-storage'
import App from '@/App'
import router from '@/router'
import store from '@/stores'
import AppConfig from '@/config'
import HttpModule from '@/modules/http'
import AlertModule from '@/modules/alert'
import AiAlertModule from '@/modules/aialert'
//import 'jquery-mousewheel'
import '@/plugins/alopex/alopex-grid/alopex-grid.min'
import '@/plugins/alopex/alopex-grid/alopex-grid.css'
import '@/assets/css/base.css'
import '@/assets/css/content.css'
import '@/assets/css/board.css'
import '@/assets/css/ai-estimate.css'
import '@/assets/js/jquery-1.12.4.min.js'
import '@/assets/js/TweenMax.min.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

/* dialog */
Vue.use(VModal, { dynamic: true })

/* vee validator */
Validator.localize('ko', VeeValidatorKo);

Validator.extend( 'password',{
  getMessage: field => field + ' 항목은 영문자,숫자,특수기호를 포함한 8자이상이어야합니다.',
  validate: value => {
    return /^.*(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).*$/.test(value)
  }
})

Validator.extend( 'phonenumber',{
  getMessage: field => field + ' 항목의 형식이 다릅니다. ex) 010-1111-2222',
  validate: value => {
    return /^\d{3}-\d{3,4}-\d{4}$/.test(value)
  }
})

Vue.use(VeeValidator);
Vue.use(VueCookies);

window.$cookies = VueCookies


/* swiper */
Vue.use(VueAwesomeSwiper, /* { default global options } */)

/* Http Configuration */
AppConfig.HTTP_CONFIG.baseURL = process.env.SERVER_BASE_URL

Vue.use(HttpModule, AppConfig)

/* modal alert */
Vue.use(AlertModule)
Vue.use(AiAlertModule)

/* vuex */
window.$store = store

/* storage */
Vue.use(Storage, {
  prefix: 'app_huckleberry_',
  drivers: ['session','local']
});

/* router */
router.beforeEach(async (to, from, next) => {
  if(to.meta.isAI){

	if(to.query.aiChannel || to.query.aiRedirectSeq){
		if(to.query.aiChannel){
			Vue.$sessionStorage.set('aiChannel',to.query.aiChannel);
		}
		if(to.query.aiRedirectSeq){
			Vue.$sessionStorage.set('redirectseq',to.query.aiRedirectSeq);
		}
		next({name:to.name});
	}

	// if(to.name === "AiLogin"){
	// 	if(Vue.$sessionStorage.get('xAuthToken')){
	// 		if(!Vue.$sessionStorage.get('redirectname')){
	// 			next({name:Vue.$sessionStorage.get('redirectname')})
	// 			return
	// 		} else {
	// 			router.go(-1)
	// 			return
	// 		}
	// 	}
	// }

    if ( to.meta.authRequired )  {
      await store.dispatch('Login/aiIsLogin')
      .then((result) => {
        if (result) {
          return next() // 페이지 이동
        } else {
          next({name:'AiLogin',params:{redirectname:to.name}})     // 로그인 화면 이동
        }
      })
    }

    // return next()
  } else {
    if ( to.meta.authRequired )  {
      // 로그인 체크
      await store.dispatch('Login/isLogin')
           .then((result) => {
              if (result) {
                return next() // 페이지 이동
              } else {
                next('/')     // 로그인 화면 이동
              }
            })
    }
  }


  return next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods: {
    hashChangeHandler: function() {
      var target = window.location.hash;
      this.$router.push(target.substring(1, target.length));
    }
  },
  mounted: function() {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.addEventListener('hashchange', this.hashChangeHandler);
    }
  },
  destroyed: function() {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.removeEventListener('hashchange', this.hashChangeHandler);
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js